import React from "react";

export default function MaticLogoBlack({classes}) {
  return (
    <svg
      width="110"
      height="32"
      viewBox="0 0 110 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={classes}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M44.1092 13.7949C43.2626 13.7949 42.5766 14.4912 42.5766 15.3504V22.366C42.5766 23.2252 43.2626 23.9215 44.1092 23.9215H51.5636V31.6925H44.1092C39.0341 31.6925 34.9199 27.5168 34.9199 22.366C34.9199 20.0271 34.9199 17.465 34.9199 15.1273C34.9199 9.97638 39.0341 5.72266 44.1092 5.72266H44.693C53.4349 5.72266 60.522 12.9937 60.522 21.866V31.6735H52.8653V22.0892C52.8653 17.5085 49.2063 13.7949 44.693 13.7949H44.1092Z"
        fill="#1F2022"
      />
      <path
        d="M61.8242 0V23.5684C61.8242 28.225 65.5437 32 70.1317 32C74.7198 32 78.4393 28.225 78.4393 23.5684V15.1179H70.7826V23.5684C70.7826 23.9333 70.4913 24.229 70.1317 24.229C69.7722 24.229 69.4809 23.9333 69.4809 23.5684V13.7822H78.4437V6.05028H69.4809V0H61.8242Z"
        fill="#1F2022"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M79.7578 31.6936V6.05078H87.4145V31.6947H79.7578V31.6936Z"
        fill="#1F2022"
      />
      <path
        d="M78.8789 0C78.8855 2.59665 80.9602 4.69784 83.5197 4.69784C86.0793 4.69784 88.154 2.59553 88.1606 0H78.8789Z"
        fill="#1F2022"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M96.1938 22.4888C96.1938 23.3368 96.8798 24.0242 97.7264 24.0242C101.817 24.0242 105.909 24.0242 110 24.0242V31.6925H97.7264C92.6513 31.6925 88.5371 27.5716 88.5371 22.4888V21.904C88.5371 13.1489 95.622 6.05078 104.365 6.05078H110.001V13.7782H104.365C99.8528 13.7782 96.1938 17.3836 96.1938 21.904V22.4888Z"
        fill="#1F2022"
      />
      <path
        d="M12.9769 19.8223C12.9769 16.6621 10.6604 14.1771 7.65665 13.7709V31.6952H0V12.5356C0 8.7037 2.94985 5.70868 7.27733 5.70868C10.9924 5.70868 13.3892 7.0522 15.6036 8.58876C16.9614 7.15597 18.1433 5.76559 21.1338 5.70868C26.9929 5.5971 33.6116 11.1486 33.6116 19.5991V31.6941H25.955V19.8223C25.955 16.6621 23.6384 14.1771 20.6347 13.7709V31.6952H12.978V19.8234L12.9769 19.8223Z"
        fill="#1F2022"
      />
    </svg>
  );
}
